import React from 'react';
import SocialIcon from './SocialIcon';
import './ShareButtons.css';

export default class ShareButtons extends React.Component {
  shareFacebook() {
    window.FB.ui({
      method: 'share_open_graph',
      // action_type: 'og.likes',
      action_type: 'og.shares',
      action_properties: JSON.stringify({
        object: {
          'og:url': this.props.url,
          'og:title': this.props.title,
          'og:description': this.props.description,
          'og:image': this.props.image
        }
      })
    });
  }

  shareTweet() {
    window.open('https://twitter.com/share?url=' + document.URL, 'twitter-popup', 'height=350,width=600');
  }

  render() {
    return (
      <div className="share-buttons">
        <SocialIcon name="facebook" isLink={false} fx={() => this.shareFacebook()} />
        <SocialIcon name="twitter" isLink={false} fx={() => this.shareTweet()} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ShareButtons.js